import apiClient from "../../../shared/infrastructure/api/client";
import type { ImportTarget, PastSessionInput, PastSessionResult } from "../domain/pastSessionImport";

/** Sends the rows and answers, in the same order, what became of each. */
export async function importPastSessions(target: ImportTarget, sessions: PastSessionInput[]): Promise<PastSessionResult[]> {
    const path = target.kind === "centre" ? `/centers/${target.centerId}/sessions/import` : "/sessions/import";
    const { data } = await apiClient.post<{ results: PastSessionResult[] }>(path, { sessions });
    return data.results;
}
